import { NextPage } from 'next'
import { FaBell } from 'react-icons/fa'
import InfiniteScroll from 'react-infinite-scroller'
import { NotificationList } from 'web_core/assets/notification'
import { LoadingSpinner } from 'web_core/assets/spinners'
import { useRequireSignedIn } from 'web_core/firebase/hooks'
import { useNotifications } from 'web_core/hooks/models/useNotifications'
import { makeLocaleStaticProps } from 'web_core/utils/static_props'
import { DefaultLayout } from '~/components/Layout/Default'
import { Heading } from '~/components/Utils/Heading'

export const getStaticProps = makeLocaleStaticProps

const Page: NextPage = () => {
  const { notifications, loadMore, isLast, fetching } =
    useNotifications('mathlog')
  useRequireSignedIn()
  return (
    <DefaultLayout
      head={{
        title: '通知一覧',
        index: false,
      }}
      leftSidebar
      rightSideBar
      categoriesMenu={{ pc: true }}
      navLinks={{ pc: true, tablet: true, sp: true }}
    >
      <Heading title="通知" icon={FaBell} />
      <InfiniteScroll
        loadMore={async () => {
          if (!fetching) await loadMore()
        }}
        hasMore={!isLast}
        loader={<LoadingSpinner />}
      >
        <NotificationList notifications={notifications} readAction />
      </InfiniteScroll>
    </DefaultLayout>
  )
}

export default Page
